module.exports = __webpack_public_path__ + "img/10.58a70b77.gif";